<template>
    <div> 
        
            <b-alert show variant="warning">
                <b-row>
                    <b-col cols="12" sm="6"	md="2"	lg="5"	xl="3">
                    <div>
                        <div class="float-left">
                            <b-button v-if="file1 !=null" variant="ligth" @click="eliminarFile()">
                                <i class="far fa-trash-alt text-danger"></i>
                            </b-button>
                        </div>
                        <div class="float-left">   
                            <b-form-file
                                v-model="file1"    
                                placeholder="Elija un archivo"
                                drop-placeholder="Suelta el archivo aquí..."
                            ></b-form-file>
                        </div>
                    </div>  
                    </b-col>
                    <b-col cols="12" sm="6"	md="2"	lg="2"	xl="1">
                        <div v-if="file1 == null">
                            <b-button title="Sin documento" disabled><i class="fa fa-upload"></i></b-button>
                        </div>
                        <div v-else>
                            <b-button title="Subir Documento" variant="success" @click="importarPagos()"><i class="fa fa-upload"></i></b-button>
                        </div>    
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="5"	xl="5">
                        <b-form inline>
                            Desde: <datepicker class="ml-4 mr-4" v-model="f1" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                            Hasta: <datepicker class="ml-4 mr-4" v-model="f2" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                        </b-form>
                    </b-col>
                    <b-col cols="12" sm="6"	md="2"	lg="2"	xl="2">
                        <b-button v-if="!loadingexcelreport" variant="warning" @click="downloadReportExcel()"><i class="fa fa-file-excel"></i> Exportar</b-button>
                        <b-button v-else variant="secondary"><i class="fa fa-spin fa-spinner"></i> Procesando</b-button>
                    </b-col>
                </b-row>
            </b-alert>
        <!-- header-bg-variant="warning" border-variant="warning" -->
        <b-card header-tag="header" border-variant="warning">
            <template slot="header">
                <b-row>
                    <b-col cols="0" sm="0"	md="5"	lg="4"	xl="1">
                        <div class="col-md-12 text-left">
                            <b-button variant="warning" @click="listaCobrosxAprobar"><i class="fa fa-sync-alt"></i> </b-button>
                        </div>    
                    </b-col> 
                    <b-col cols="12" sm="10" md="10" lg="6" xl="2">          
                        <b-input-group>
                            <b-form-input 
                                class="input-placedark input-dark" 
                                placeholder="Busqueda por RUC" 
                                type="text" 
                                v-model="rucclientexAprobar" 
                                @input="searchByRuc(1)">
                            </b-form-input>
                            <b-input-group-text slot="append">
                                <b-button variant="warning" size="sm" @click="closeDataCliente()" class="p-0 m-0"><i class="fa fa-times ml-2 mr-2"></i></b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <template v-if="searchclientexAprobar">
                            <b-list-group class="searcher-field">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                            </b-list-group>
                        </template>
                        <b-list-group v-if="listaclientesxAprobar" class="searcher-field">
                            <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                            <template v-for="(item, index) in listaClientesxAprobar" class="buscarRuc">
                            <b-list-group-item :key="index" @click="setCliente(item, 1)" class="searcher-result">
                                {{item.receiver.idReceptor + ' - ' + item.receiver.razonSocial}}
                            </b-list-group-item>
                            </template>
                        </b-list-group>
                    </b-col>  
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="2"></b-col>
                    <b-col cols="8" sm="8"	md="5"	lg="3"	xl="3">
                        <div class="negritatitle">CUENTAS POR COBRAR <b-badge variant="warning">Pendientes de aprobacion</b-badge></div>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="4"	xl="2">
                       <b-form-group horizontal label="Orden" class="mb-0">
                            <b-input-group>
                            <b-form-select v-model="orden" slot="append" @input="listaCobrosxAprobar">
                                <option :value="'asc'">Más Antiguo</option>
                                <option :value="'desc'">Más Reciente</option>
                            </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="5"	xl="2">
                       <b-form-group horizontal label="Mostrar" class="mb-0">
                            <b-input-group>
                                <b-form-select v-model="limite" slot="append" @input="listaCobrosxAprobar">
                                <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                        <b-button size="sm" v-b-modal.buscarcomprobante variant="success"><i class="fa fa-search"></i> Buscar Comprobante</b-button>
                    </b-col> -->
                </b-row>
            </template>
            <b-table 
                striped 
                hover 
                small 
                responsive
                outlined
                :filter="filter_pendientes"
                :items="cuentasxAprobar"
                :fields="xaprobar_fields"
                :busy="isBusy"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
                <template slot="antiguedad" slot-scope="row">
                    <i v-if="row.item.morosidadtotal === 1" class="fa fa-smile fa-2x text-success"></i>
                    <i v-else-if="row.item.morosidadtotal === 2" class="fa fa-meh fa-2x text-warning"></i>
                    <i v-else-if="row.item.morosidadtotal === 3" class="fa fa-frown fa-2x text-danger"></i>
                </template>
                <template slot="cantidad" slot-scope="row">
                    {{ row.item.cantidad }}
                </template>
                <template slot="receptor" slot-scope="row">
                   <b-link @click="enviarAestadoCuenta(row.item,1)">{{ row.item.idReceptor }}</b-link>  - {{ row.item.receiver.razonSocial }}
                </template>
                <template slot="deudatotalSoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles > 0">
                        S/ {{row.item.deudatotalSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadasoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles-row.item.deudapagadasoles > 0">
                        S/ {{(row.item.deudatotalSoles-row.item.deudapagadasoles).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudatotalDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares > 0">
                        $ {{row.item.deudatotalDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadaDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares-row.item.deudapagadaDolares > 0">
                        $ {{(row.item.deudatotalDolares-row.item.deudapagadaDolares).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="acciones" slot-scope="row">
                   <button
                        v-show="!row.item.loading"
                        type="button"
                        class="btn"
                        size="sm"
                        @click="mostrarDetalles(row, 1, row.index)"
                        title="Mas opciones"
                        >
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth">
                        <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                </template>
                <template slot="row-details" slot-scope="row">
                    <b-card>
                        <b-table striped hover :items="row.item.detalles" :fields="docxaprobar_fields" :busy="row.item.loading">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Cargando...</strong>
                            </div>
                            <template slot="antiguedad" slot-scope="row">
                                <i v-if="row.item.morosidad === 1" class="fa fa-smile fa-2x text-success"></i>
                                <i v-else-if="row.item.morosidad === 2" class="fa fa-meh fa-2x text-warning"></i>
                                <i v-else-if="row.item.morosidad === 3" class="fa fa-frown fa-2x text-danger"></i>
                            </template>
                            <template slot="emision" slot-scope="row">
                                    <div v-if="row.item && row.item.fechaEmision">
                                        {{ row.item.fechaEmision | moment('DD/MM/YYYY') }}
                                    </div>
                            </template>
                            <template slot="vencimiento" slot-scope="row">
                                <div v-if="row.item && row.item.vencimiento">
                                    {{ row.item.vencimiento | moment('DD/MM/YYYY') }}
                                </div>
                            </template>
                            <template slot="tiempo" slot-scope="row">
                                <div v-if="row.item && row.item.fechaEmision">
                                    <!-- {{ row.item.fechaEmision | moment('from') }} -->
                                </div>
                            </template>
                            <template slot="deudatotalSoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles > 0">
                                    S/ {{row.item.importeTotalSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialsoles" slot-scope="row">
                                <div v-if="row.item.importePagadoSoles > 0">
                                    S/ {{row.item.importePagadoSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadasoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                                    S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudatotalDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares > 0">
                                    $ {{row.item.importeTotalDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialdolares" slot-scope="row">
                                <div v-if="row.item.importePagadoDolares > 0">
                                    S/ {{row.item.importePagadoDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadaDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                                    $ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <b-button size="sm" v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(row.item)"><i class="fa fa-tv"></i></b-button>
                                <b-button size="sm" v-b-modal.registropago1 v-b-tooltip.hover variant="success" class="ml-2" @click="getDocumento(row, 1)" title="Registrar pago"><i class="fa fa-money-bill-alt"></i></b-button>
                                <b-button size="sm" v-show="row.item.aprobado===2" v-b-modal.motivorechazo v-b-tooltip.hover variant="danger" class="ml-2" @click="motivoRechazo(row, 1)" title="Motivo Rechazo"><i class="fa fa-exclamation-circle"></i></b-button>
                            </template> 
                        </b-table>
                    </b-card>
                </template>
            </b-table>
            <b-modal id="motivorechazo" size="md" title="Motivo Rechazo" v-model="motrechazo">
                <div role="group">
                    {{ this.observacionRechazo }}
                </div>
                <div slot="modal-footer" class="w-100">
                    <b-btn size="sm" class="float-right" variant="danger" @click="closerechazo">
                        Cerrar
                    </b-btn>
                </div>
            </b-modal>
            <b-modal id="registropago1" size="lg" title="Registrar Pago" v-model="registrarpago">
                <div role="group">
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-alert v-if="detallesCuentaAprobada" show variant="warning" class="text-center"><b>Cliente: </b> {{ detallesCuentaAprobada.receiver.idReceptor }}-{{ detallesCuentaAprobada.receiver.razonSocial }}</b-alert>
                        <b-table striped hover :items="[detallesCuentaAprobada]" :fields="detallecuentaaprobada_fields">
                            <template slot="serie" slot-scope="row">
                                {{ filaActual.item.serie }}
                                <div style="display:none;">
                                 {{ arrayCuotas = filaActual.item.cronograma}}
                                </div>
                            </template>
                            <template slot="numero" slot-scope="row">
                                {{ filaActual.item.numero }}
                            </template>
                            <template slot="totalsoles" slot-scope="row">
                                S/ {{ filaActual.item.importeTotalSoles.toFixed(2) }}
                            </template>
                            <template slot="pagadosoles" slot-scope="row">
                                S/ {{(filaActual.item.importeTotalSoles-filaActual.item.importePagadoSoles).toFixed(2)}}
                            </template>
                            <template slot="totaldolares" slot-scope="row">
                                US$ {{ filaActual.item.importeTotalDolares.toFixed(2) }}
                            </template>
                            <template slot="pagadodolares" slot-scope="row">
                                US$ {{(filaActual.item.importeTotalDolares-filaActual.item.importePagadoDolares).toFixed(2)}}
                            </template>
                        </b-table>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                            <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                {{ fpago.nombre }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodemoneda" disabled>
                            <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                {{ moneda.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <div v-if="cargandoBancos" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template v-else>
                            <div>
                                <b-form-select v-model="banco" class="mb-3" >
                                <template v-slot:first>
                                    <option :value="null" disabled>-- Selecciona una cuenta --</option>
                                </template>
                                <option v-for="banco in listaBancos" :value="banco" :key="banco.numeroCuenta">{{ banco.banco }} / {{ banco.moneda }} / {{ banco.numeroCuenta }} / {{ banco.cci }}</option>
                                </b-form-select>
                            </div>
                        </template>
                    </b-col>
                </b-row>
                <b-row class="mb-3 text-center" v-if="listaBancos.length === 0 && formadepago.codigo != '000'">
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-badge variant="warning">No se encontro informacion de bancos, por favor diríjase al perfil de administrador para agregarlos</b-badge>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="importe" type="text" :value="pago.importePagado" placeholder="Importe"></b-form-input>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="numerooperacion" type="text" placeholder="Nro. operación"></b-form-input>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <datepicker v-model="fpago" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-textarea
                            v-model="observaciones"
                            placeholder="Observaciones..."
                            rows="3"
                            max-rows="12"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
                </div>
                <template v-if="arrayCuotas !=''">
                <b-alert show variant="warning" class="text-center"><b>Registro de Cuotas</b></b-alert>
                <b-table :items="arrayCuotas" :fields="detalleCuotas_fields"></b-table>
                <h5>Total Cuotas: {{sumaCuotas()}}</h5>
                </template>
                <div slot="modal-footer" class="w-100">
                    <div v-if="nivelusuario">
                    <b-btn v-if="!sendpago" :disabled="validFormularioPago()" size="sm" class="float-right" variant="primary" @click="pagoDeuda(1)">
                        Registrar
                    </b-btn>
                    <b-btn v-else size="sm" class="float-right" variant="secondary">
                        <i class="fa fa-spin fa-spinner"></i> Registrando ...
                    </b-btn>
                    </div>
                </div>
            </b-modal>
            <b-modal id="buscarcomprobante" size="lg" title="Buscar comprobante" v-model="buscarcomp">
                <div role="group">
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-group horizontal class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="filtro" @change="filtroDocumento()" placeholder="Filtrar por Documento" />
                                <b-input-group-append>
                                <b-btn @click="filtro = ''">Limpiar</b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        </b-col>
                    </b-row><br>
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                            <b-table :fields="docxaprobar_fields" :items="docfiltrado" :busy="filtrando">
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong> Cargando...</strong>
                                </div>
                            </b-table>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
            <b-row>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                </b-col>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <div class="float-right">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" @input="listaCobrosxAprobar" :per-page="limite"></b-pagination>
                    </div>            
                </b-col>
            </b-row>
        </b-card>
        <!-- header-bg-variant="success" border-variant="success" -->
        <b-card header-tag="header" border-variant="success">
            <template slot="header">
                <b-row>
                    <b-col cols="0" sm="0"	md="5"	lg="5"	xl="1">
                        <div class="col-md-12 text-left">
                            <b-button variant="success" @click="listaCobrosAprobadas"><i class="fa fa-sync-alt"></i> </b-button>
                        </div>    
                    </b-col>
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="2">          
                        <b-input-group>
                            <b-form-input 
                                class="input-placedark input-dark" 
                                placeholder="Busqueda por RUC" 
                                type="text" 
                                v-model="rucclienteAprobado" 
                                @input="searchByRuc(2)">
                            </b-form-input>
                            <b-input-group-text slot="append">
                                <b-button variant="warning" size="sm" @click="closeDataCliente()" class="p-0 m-0"><i class="fa fa-times ml-2 mr-2"></i></b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <template v-if="searchclienteAprobado">
                            <b-list-group class="searcher-field">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                            </b-list-group>
                        </template>
                        <b-list-group v-if="listaclientesAprobados" class="searcher-field">
                            <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                            <template v-for="(item, index) in listaClientesAprobados" class="buscarRuc">
                            <b-list-group-item :key="index" @click="setCliente(item, 2)" class="searcher-result">
                                {{item.receiver.idReceptor + ' - ' + item.receiver.razonSocial}}
                            </b-list-group-item>
                            </template>
                        </b-list-group>
                    </b-col>  
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="2"></b-col>
                    <b-col cols="12" sm="12"	md="7"	lg="7"	xl="3" class="text-left">
                        <div class="negritatitle">CUENTAS POR COBRAR <b-badge variant="success">Aprobadas</b-badge></div>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                       <b-form-group horizontal label="Orden" class="mb-0">
                            <b-input-group>
                            <b-form-select v-model="ordenA" slot="append" @input="listaCobrosAprobadas">
                                <option :value="'asc'">Más Antiguo</option>
                                <option :value="'desc'">Más Reciente</option>
                            </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4" sm="4"	md="2"	lg="2"	xl="2">
                       <b-form-group horizontal label="Mostrar" class="mb-0">
                            <b-input-group>
                                <b-form-select v-model="limiteA" slot="append" @input="listaCobrosAprobadas">
                                <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>  
            </template>
            <b-table 
                striped 
                hover 
                small 
                responsive
                outlined
                :filter="filter_aprobadas"
                :items="cuentasAprobadas"
                :fields="xaprobar_fields"
                :busy="aprobadas"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
                <template slot="antiguedad" slot-scope="row">
                    <i v-if="row.item.morosidadtotal === 1" class="fa fa-smile fa-2x text-success"></i>
                    <i v-else-if="row.item.morosidadtotal === 2" class="fa fa-meh fa-2x text-warning"></i>
                    <i v-else-if="row.item.morosidadtotal === 3" class="fa fa-frown fa-2x text-danger"></i>
                </template>
                <template slot="cantidad" slot-scope="row">
                    {{ row.item.cantidad }}
                </template>
                <template slot="emision" slot-scope="row">
                    <div v-if="row.item.receiver && row.item.receiver.fechaCreacion">
                        <!-- {{ row.item.receiver.fechaCreacion | moment('DD/MM/YYYY') }} -->
                    </div>
                </template>
                <template slot="vencimiento" slot-scope="row">
                    <div v-if="row.item && row.item.vencimiento">
                        <!-- {{ row.item.vencimiento |  moment('DD/MM/YYYY') }} -->
                    </div>
                    
                </template>
                <template slot="receptor" slot-scope="row">
                    <b-link @click="enviarAestadoCuenta(row.item,1)">{{ row.item.idReceptor }}</b-link> - {{ row.item.receiver.razonSocial }}
                </template>
                <template slot="deudatotalSoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles > 0">
                        S/ {{row.item.deudatotalSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadasoles" slot-scope="row">
                    <div v-if="row.item.deudatotalSoles-row.item.deudapagadasoles > 0">
                       S/ {{(row.item.deudatotalSoles-row.item.deudapagadasoles).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudatotalDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares > 0">
                        $ {{row.item.deudatotalDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadaDolares" slot-scope="row">
                    <div v-if="row.item.deudatotalDolares-row.item.deudapagadaDolares > 0">
                        $ {{(row.item.deudatotalDolares-row.item.deudapagadaDolares).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="acciones" slot-scope="row">
                    <button
                        v-show="!row.item.loading"
                        type="button"
                        class="btn"
                        size="sm"
                        @click="mostrarDetalles(row, 2, row.index)"
                        title="Mas opciones"
                        >
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth">
                        <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                    <b-button v-b-modal.notificaciones size="sm" variant="ligth" class="ml-2" @click="vernotificaciones(row)">
                        <i class="fa fa-bell" style="position:relative; left: 5px; z-index: 1"></i>
                        <b-badge pill variant="danger" style="position:relative; top: -10px; z-index: 10">
                            <span v-if="row.item.alertas != 0">{{row.item.alertas}}</span>
                        </b-badge>
                    </b-button>
                </template>
                <template slot="row-details" slot-scope="row">
                    <b-card>
                        <b-table :tbody-tr-class="rowClass" striped hover :items="row.item.detalles" :fields="docxaprobar_fields" :busy="row.item.loading">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Cargando...</strong>
                            </div>
                            <template slot="antiguedad" slot-scope="row">
                                <i v-if="row.item.morosidad === 1" class="fa fa-smile fa-2x text-success"></i>
                                <i v-else-if="row.item.morosidad === 2" class="fa fa-meh fa-2x text-warning"></i>
                                <i v-else-if="row.item.morosidad === 3" class="fa fa-frown fa-2x text-danger"></i>
                            </template>
                            <template slot="emision" slot-scope="row">
                                <div v-if="row.item && row.item.fechaEmision">
                                    <!-- {{ row.item.fechaEmision |  moment('DD/MM/YYYY') }} -->
                                </div>
                                
                            </template>
                            <template slot="vencimiento" slot-scope="row">
                                <div v-if="row.item && row.item.vencimiento">
                                    <!-- {{ row.item.vencimiento | moment('DD/MM/YYYY') }} -->
                                </div>
                            </template>
                            <template slot="tiempo" slot-scope="row">
                                <div>
                                    <!-- {{ row.item.fechaEmision | moment('from') }} -->
                                </div>
                            </template>
                           <template slot="deudatotalSoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles > 0">
                                    S/ {{row.item.importeTotalSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialsoles" slot-scope="row">
                                <div v-if="row.item.importePagadoSoles > 0">
                                    S/ {{row.item.importePagadoSoles.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadasoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                                    S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudatotalDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares > 0">
                                    $ {{row.item.importeTotalDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="parcialdolares" slot-scope="row">
                                <div v-if="row.item.importePagadoDolares > 0">
                                    S/ {{row.item.importePagadoDolares.toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="deudapagadaDolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                                    $ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <b-button size="sm" v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(row.item)"><i class="fa fa-tv"></i></b-button>
                                <b-button size="sm" v-b-modal.registropago1 v-b-tooltip.hover variant="success" class="ml-2" @click="getDocumento(row, 2)" title="Registrar pago"><i class="fa fa-money-bill-alt"></i></b-button>
                                <b-button size="sm" v-b-modal.listarpagos v-b-tooltip.hover variant="primary" class="ml-2" @click="watchPayment(row)" title="Listar Pagos"><i class="fa fa-eye"></i></b-button>
                            </template> 
                        </b-table>
                    </b-card>
                </template>
            </b-table>
            <b-modal id="listarpagos" size="lg" v-model="listarpagos">
                <template slot="modal-title">
                    {{ titlepagos }}
                </template>
                <div v-if="!editando">
                    <b-table :fields="pagos_fields" :items="listaPagos" :busy="cargandopagos">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template v-if="row.item && row.item.registrador && row.item.registrador !=''" slot="registrador" slot-scope="row">
                          {{row.item.registrador.nomUsuario}} {{row.item.registrador.appUsuario}}
                        </template>
                        <template slot="fregistro" slot-scope="row">
                            <!-- {{ row.item.created_at |  moment('DD/MM/YYYY') }} -->
                        </template>
                        <template slot="fpago" slot-scope="row">
                            <!-- {{ row.item.fechaPago |  moment('DD/MM/YYYY') }} -->
                        </template>
                        <template slot="importe" slot-scope="row">
                            <template v-if="row.item.tipoMoneda == 'PEN'">
                                S/ {{ row.item.importePagado }}
                            </template>
                            <template v-else-if="row.item.tipoMoneda == 'USD'">
                                $ {{ row.item.importePagado }}
                            </template>
                        </template>
                        <template slot="acciones" slot-scope="row">
                            <b-button-group>
                                <b-button size="sm" @click="row.toggleDetails">
                                {{ row.detailsShowing ? '-' : '+' }}
                                </b-button>
                                <div v-if="nivelusuario">
                                    <b-button size="sm" variant="primary" @click="editPago(row)"><i class="fa fa-pen"></i></b-button>
                                    <b-button size="sm" variant="danger" @click="deletePago(row)"><i class="fa fa-trash"></i></b-button>
                                </div>             
                            </b-button-group>
                        </template>
                        <template v-slot:row-details="row">
                            <b-card>
                                {{ row.item.observaciones }}
                            </b-card>
                        </template>
                    </b-table>               
                </div>
                <div v-else>
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                            <b-alert v-if="detallesCuentaAprobada" show variant="warning" class="text-center"><b>Cliente: </b> {{ detallesCuentaAprobada.receiver.idReceptor }}-{{ detallesCuentaAprobada.receiver.razonSocial }}</b-alert>
                            <b-table striped hover :items="[pago]" :fields="detallecuentaaprobada_fields">
                                <template slot="serie" slot-scope="row">
                                    {{ row.item.creditdocument.serie }}
                                </template>
                                <template slot="numero" slot-scope="row">
                                    {{ row.item.creditdocument.numero }}
                                </template>
                                <template slot="totalsoles" slot-scope="row">
                                    S/ {{ row.item.creditdocument.importeTotalSoles.toFixed(2) }}
                                </template>
                                <template slot="pagadosoles" slot-scope="row">
                                    S/ {{(row.item.creditdocument.importeTotalSoles-row.item.creditdocument.importePagadoSoles).toFixed(2)}}
                                </template>
                                <template slot="totaldolares" slot-scope="row">
                                    US$ {{ row.item.creditdocument.importeTotalDolares.toFixed(2) }}
                                </template>
                                <template slot="pagadodolares" slot-scope="row">
                                    US$ {{(row.item.creditdocument.importePagadoDolares-row.item.creditdocument.importePagadoDolares).toFixed(2)}}
                                </template>
                            </b-table>
                        </b-col>
                    </b-row><br>
                    <b-row>
                        <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                            <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                                <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                    {{ fpago.nombre }}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                            <select class="custom-select mr-sm-2 input-placedark input-dark" disabled v-model="tipodemoneda">
                                <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                    {{ moneda.descripcion }}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                            <b-form-input v-model="importe" type="text" placeholder="Importe"></b-form-input>
                        </b-col>
                    </b-row><br>
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" v-if="pago.infoBanco && editbank">
                            <b-input-group>
                                <b-form-input class="input-placedark input-dark" :placeholder="pago.infoBanco.banco+' / '+pago.infoBanco.moneda+' / '+pago.infoBanco.numeroCuenta+' / '+pago.infoBanco.cci"></b-form-input>
                                <b-input-group-text slot="append">
                                    <button class="btn btn-warning btn-sm p-0 pl-1 pr-1 sinresultados" @click="editBank()"><i class="fa fa-pencil-alt"></i></button>
                                </b-input-group-text>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12" v-else>
                            <b-row>
                                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                    <div v-if="cargandoBancos" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> Cargando...</strong>
                                    </div>
                                    <template v-else>
                                        <div>
                                            <b-form-select v-model="banco" class="mb-3" >
                                            <template v-slot:first>
                                                <option :value="null" disabled>-- Selecciona una cuenta --</option>
                                            </template>
                                            <option v-for="banco in listaBancos" :value="banco" :key="banco.numeroCuenta">{{ banco.banco }} / {{ banco.moneda }} / {{ banco.numeroCuenta }} / {{ banco.cci }}</option>
                                            </b-form-select>
                                        </div>
                                    </template>
                                </b-col>
                                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                    <b-form-input v-model="numerooperacion" type="text" placeholder="Nro. operación"></b-form-input>
                                </b-col>
                                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                    <datepicker v-model="fpago" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row><br>
                    <b-row v-if="pago.infoBanco && editbank">
                        <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                            <b-form-input v-model="numerooperacion" type="text" placeholder="Nro. operación"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                            <datepicker v-model="fpago" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                        </b-col>
                    </b-row><br>
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                            <b-form-textarea
                                v-model="observaciones"
                                placeholder="Observaciones..."
                                rows="3"
                                max-rows="12"
                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="ncpagos.length != 0">
                     <b-alert align="center" variant="danger" show>{{ncpagos[0].observaciones}}</b-alert> 
               
                <b-table :items="ncpagos" :fields="pagos_fields2">
                        <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template v-if="row.item && row.item.registrador && row.item.registrador !=''" slot="registrador" slot-scope="row">
                        {{row.item.registrador.nomUsuario}} {{row.item.registrador.appUsuario}}
                    </template>
                    <template slot="fregistro" slot-scope="row">
                        <!-- {{ row.item.created_at |  moment('DD/MM/YYYY') }} -->
                    </template>
                    <template slot="fpago" slot-scope="row">
                        <!-- {{ row.item.fechaPago |  moment('DD/MM/YYYY') }} -->
                    </template>
                    <template slot="importe" slot-scope="row">
                        <template v-if="row.item.tipoMoneda == 'PEN'">
                            S/ {{ row.item.importePagado }}
                        </template>
                        <template v-else-if="row.item.tipoMoneda == 'USD'">
                            $ {{ row.item.importePagado }}
                        </template>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            {{ row.item.observaciones }} 
                        </b-card>
                    </template>
                </b-table>
                 </div>
                <div slot="modal-footer" class="w-100 text-right">
                    <template v-if="viewbuttonback">
                        <b-button size="sm" class="mr-4" variant="warning" @click="regresarListaPagos()"><i class="fa fa-hand-point-left"> Atras</i></b-button>
                        <b-button size="sm" class="mr-4" variant="primary" v-if="!actualizandopago" @click="pagoDeuda(2)"><i class="fa fa-sync-alt"> Actualizar</i></b-button>
                        <b-button size="sm" class="mr-4" variant="secondary" v-else><i class="fa fa-spin fa-spinner"></i> Actualizando</b-button>
                    </template> 
                    <b-btn size="sm" variant="danger" @click="cerrarlistapagos"> Cerrar</b-btn>
                </div>
            </b-modal>
            <b-modal id="notificaciones" size="lg" title="Notificaciones" v-model="notificaciones">
                <div>
                    <div v-if="cargandonotificaciones" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template v-else>
                        <b-table :fields="notificaciones_fields" :items="listaNotificaciones" :busy="cargandopagos" >
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template slot="documento" slot-scope="row">
                            {{ row.item.alerta[0].serie }}-{{ row.item.alerta[0].numero }}
                        </template>
                        <template slot="fechaemision" slot-scope="row">
                            <!-- {{ row.item.alerta[0].fechaemision | moment('DD/MM/YYYY hh:mm:ss A') }} -->
                        </template>
                        <template slot="importe" slot-scope="row">
                            {{ row.item.alerta[0].importe }}
                        </template>
                        <template slot="nrooperacion" slot-scope="row">
                            {{ row.item.alerta[0].nrooperacion }}
                        </template>
                        <template slot="banco" slot-scope="row">
                            {{ row.item.alerta[0].banco }}
                        </template>
                        <template slot="tipomoneda" slot-scope="row">
                            {{ row.item.alerta[0].tipomoneda }}
                        </template>
                        <template slot="observacion" slot-scope="row">
                            {{ row.item.alerta[0].observacion }}
                        </template>
                    </b-table>       
                    </template>
                </div>
                <div slot="modal-footer" class="w-100">
                    <b-btn size="sm" class="float-right" variant="danger" @click="cerrarNotificaciones">
                        Cerrar
                    </b-btn>
                </div>
            </b-modal>
            <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previewmodal">
                <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                <template v-else>
                <template v-if="pdfobject !==''">
                    <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                </template>
                </template>
            </b-modal>
            <b-row>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <p>Mostrando del {{desdeA}} al {{hastaA}} de un total de {{totalA}} registros</p>
                </b-col>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <div class="float-right">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPageA" @input="listaCobrosAprobadas" :per-page="limiteA"></b-pagination>
                    </div>            
                </b-col>
            </b-row>
        </b-card>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import { TipoMoneda } from '@/shared/utils'
import { FormaPago } from '@/shared/utils'
import Datepicker from 'vuejs-datepicker'
import download from 'downloadjs'
    export default {
        name: 'CuentaCobrar',
        components: {
            Datepicker
        },
        data:() => {
            return {
                rucclientexAprobar: '',
                rucclienteAprobado: '',
                searchclientexAprobar: false,
                searchclienteAprobado: false,
                listaclientesxAprobar: false,
                listaclientesAprobados: false,
                listaClientesxAprobar: [],
                listaClientesAprobados: [],
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                limite: 50,
                orden: 'desc',
                currentPage: 1,
                totalA: 0.00,
                desdeA: 0.00,
                hastaA: 0.00,
                limiteA: 50,
                ordenA: 'desc',
                currentPageA: 1,
                f1: '',
                f2: '',
                titleexcelrango: 'Reporte de emisiones ',
                loadingexcelreport: false,
                actualizandopago: false,
                cargandoBancos: false,
                detallesCuentaAprobada: null,
                selected: null,
                fpago: '',
                currentdate: '',
                banco: null,
                numerooperacion: '',
                listaBancos: [],
                motrechazo: false,
                cargandopagos: false,
                listarpagos: false,
                filtrando: false,
                buscarcomp: false,
                filtro: '',
                aprobadas: false,
                viewdetails: false,
                refresh: false,
                morosidad: 1,
                idReceptor: '',
                sendpago: false,
                tipodemoneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                formadepago: {
                    codigo: '000',
                    nombre: 'Elige Forma de Pago'
                },
                formaPago: FormaPago,
                tipoMoneda: TipoMoneda,
                observaciones: '',
                importe: '',
                registrarpago: false,
                itemactual: -1,
                candado: false,
                isBusy: false,
                isBusy2: false,
                perPage: 5,
                filter_pendientes: null,
                filter_aprobadas: null,
                filterOn: [],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                xaprobar_fields: [
                    {key: 'antiguedad', label: '', _showDetails: false},
                    {key: 'cantidad', label: 'Nº Doc.', sortable: true, _showDetails: false},
                    {key: 'receptor', label: 'Receptor', sortable: false, _showDetails: false},
                    {key: 'deudatotalSoles', label: 'Total Soles', sortable: true, _showDetails: false},
                    {key: 'deudapagadasoles', label: 'Deuda Soles', sortable: true, _showDetails: false},
                    {key: 'deudatotalDolares', label: 'Total Dolares', sortable: true, _showDetails: false},
                    {key: 'deudapagadaDolares', label: 'Deuda Dolares', sortable: true, _showDetails: false},
                    {key: 'acciones', label: 'Acciones', _showDetails: false}
                ],
                notificaciones_fields: [
                    {key: 'documento', label: 'Documento', _showDetails: false},
                    {key: 'fechaemision', label: 'Emision', _showDetails: false},
                    {key: 'importe', label: 'Importe', _showDetails: false},
                    {key: 'nrooperacion', label: 'Operacion', _showDetails: false},
                    {key: 'banco', label: 'Banco', _showDetails: false},
                    {key: 'tipomoneda', label: 'Moneda', _showDetails: false},
                    {key: 'observacion', label: 'Observaciones', sortable: true, _showDetails: false}
                ],
                detallecuentaaprobada_fields: [
                    {key: 'serie', label: 'Serie', sortable: true},
                    {key: 'numero', label: 'Numero', sortable: true},
                    {key: 'totalsoles', label: 'Total S/', sortable: true},
                    {key: 'pagadosoles', label: 'Debe S/', sortable: true},
                    {key: 'totaldolares', label: 'Total USD', sortable: true},
                    {key: 'pagadodolares', label: 'Debe USD', sortable: true},
                ],
                detalleCuotas_fields: [
                    {key: 'identificadorCuota', label: 'Cuota', sortable: true},
                    {key: 'fechaPagoCuota', label: 'Fecha Pago', sortable: true},
                    {key: 'montoPagoCuota', label: 'Monto Cuota', sortable: true},
                ],
                items: [],
                itemsdetalles: [],
                cuentasxAprobar: [],
                cuentasAprobadas: [],
                docxaprobar_fields: [
                    {key: 'antiguedad', label: ''},
                    {key: 'serie', label: 'Serie', sortable: true},
                    {key: 'numero', label: 'Numero', sortable: false},
                    {key: 'emision', label: 'Emision', sortable: false},
                    {key: 'vencimiento', label: 'Vencimiento', sortable: false},
                    {key: 'tiempo', label: 'Tiempo', sortable: false},
                    {key: 'deudatotalSoles', label: 'Total S/', sortable: true, _showDetails: false},
                    {key: 'parcialsoles', label: 'Parcial S/', sortable: true, _showDetails: false},
                    {key: 'deudapagadasoles', label: 'Deuda S/', sortable: true, _showDetails: false},
                    {key: 'deudatotalDolares', label: 'Total US$', sortable: true, _showDetails: false},
                    {key: 'parcialdolares', label: 'Parcial US$', sortable: true, _showDetails: false},
                    {key: 'deudapagadaDolares', label: 'Deuda US$', sortable: true, _showDetails: false},
                    {key: 'acciones', label: 'Acciones'}
                ],
                pagos_fields: [
                    {key: 'registrador',label:'Nombre Usuario'},     
                    {key: 'fregistro', label: 'Fecha de Registro', sortable: true},
                    {key: 'fpago', label: 'Fecha de Pago', sortable: true},
                    {key: 'importe', label: 'Importe', sortable: true},          
                    {key: 'acciones', label: 'Acciones', sortable: true}
                ],
                pagos_fields2: [
                    {key: 'fregistro', label: 'Fecha de Registro', sortable: true},
                    {key: 'fpago', label: 'Fecha de Pago', sortable: true},
                    {key: 'importe', label: 'Importe', sortable: true},          
                ],
                pago: {},
                moroso: 0,
                filaActual: {},
                docfiltrado: [],
                listaPagos: [],
                registropagotipo: 0,
                indexApobar: 0,
                indexApobado: 0,
                listaNotificaciones: [],
                notificaciones: false,
                cargandonotificaciones: false,
                pdfobject: '',
                previewmodal: false,
                cargandopdf2: false,
                observacionRechazo: '',
                editando: false,
                titlepagos: 'Listar Pagos',
                viewbuttonback: false,
                editbank: true,
                refreshpago: false,
                arrayCuotas:[],
                ncpagos:[],
                nivelusuario:false,
                user:'',
                file1:null,

            }
        },
        mounted(){
            this.listaCobrosxAprobar()
            this.listaCobrosAprobadas()
            this.initDates()
            this.rangouser()
        },
        watch: {
            filtro: function () {
                if(this.filtro.length === 0){
                    this.listaCobrosxAprobar()
                }
            },
            rucclientexAprobar: function () {
                if(this.rucclientexAprobar.length == 0){
                    this.closeDataCliente()
                }
            },
            rucclienteAprobado: function () {
                if(this.rucclienteAprobado.length == 0){
                    this.closeDataCliente()
                }
            }   
        },
        methods: {
            closeDataCliente: function () {
                this.rucclientexAprobar = ''
                this.rucclienteAprobado = ''
                this.searchclientexAprobar = false,
                this.searchclienteAprobado = false,
                this.listaclientesxAprobar = false,
                this.listaclientesAprobados = false,
                this.listaClientesxAprobar = [],
                this.listaClientesAprobados = []
            },
            setCliente: function (data, tipo) {
                if(tipo == 1){
                    this.total = 1
                    this.desde = 1
                    this.hasta = 1
                    this.cuentasxAprobar = [data]
                }else if(tipo == 2){
                    this.totalA = 1
                    this.desdeA = 1
                    this.hastaA = 1
                    this.cuentasAprobadas = [data] 
                }
                this.searchclientexAprobar = false
                this.searchclienteAprobado = false
                this.listaclientesxAprobar = false
                this.listaclientesAprobados = false
            },
            searchByRuc: function (tipo) {
                let aprobado = ''
                let p = ''
                if(tipo == 1){
                    aprobado = 1
                    p = this.rucclientexAprobar
                    this.searchclientexAprobar = true
                }else if(tipo == 2){
                    aprobado = 2
                    p = this.rucclienteAprobado
                    this.searchclienteAprobado = true
                }
                if((tipo==1 && this.rucclientexAprobar.length > 2) || (tipo==2 && this.rucclienteAprobado.length > 2)){
                    axios
                    .post(process.env.VUE_APP_API_URL + 'documentoscredito/buscar/enviado', {
                        token: this.$store.getters.userToken,
                        p: p,
                        aprobado: aprobado
                    })
                    .then(response => (
                        this.setResponseSearch(response.data.response, tipo)
                    ))
                    .catch(error => {
                        this.searchclientexAprobar = false
                        this.searchclienteAprobado = false
                    })
                }
            },
            setResponseSearch: function (data, tipo) {
                if(tipo == 1){
                    this.listaClientesxAprobar = data,
                    this.searchclientexAprobar = false,
                    this.listaclientesxAprobar = true
                }else if(tipo == 2){
                    this.listaClientesAprobados = data,
                    this.searchclienteAprobado = false,
                    this.listaclientesAprobados = true
                }   
            },
            downloadReportExcel: function () {
                let fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                let fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                if(this.f1 != '' || this.f2 != ''){
                    this.f1 == '' ? fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                    this.f2 == '' ? fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha2 = this.$moment(this.f2).format('YYYY-MM-DD HH:mm:ss')
                }
                let file = ''
                let tag = document.createElement('i')
                tag.classList.add('fa','fa-spin', 'fa-spinner')
                let name = this.titleexcelrango +' '+ fecha1 + '-' + fecha2 + '.xlsx'            
                this.loadingexcelreport = true
                this.$swal({
                    title: 'Procesando Reporte',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                })
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/reporte/emitidos/excel', {
                    token: this.$store.getters.userToken,               
                    f1: fecha1,
                    f2: fecha2
                })
                .then(response => (
                file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64,
                this.loadingexcelreport = false,               
                download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
                this.$swal.close()
                ))
                .catch(error => {})
            },
            deletePago: function (row) {
                this.$swal({
                title: 'Eliminar Pago',
                text: 'Seguro de eliminar este pago ???',
                icon: 'warning',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                        axios
                        .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/regularizar/eliminar',{
                            token: this.$store.getters.userToken,
                            id: row.item.idDocumentoCreditoPago
                        })
                        .then(response => (
                            this.$snotify.success(response.data.msg,'Exito'),
                            this.listarpagos = false
                        ))
                        .catch(error => (
                            this.$snotify.error('Ups, Hubo un error intentelo luego!','Error')
                        ))
                    }
                })
            },
            initPagos: function () {
                this.tipodemoneda = {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                this.formadepago = {
                    codigo: '000',
                    nombre: 'Elige Forma de Pago'
                }
            },
            editBank: function () {
                this.editbank = false
            },
            regresarListaPagos: function () {
                this.titlepagos = 'Listar Pagos'
                this.editando = false
                this.editbank = true
                this.viewbuttonback = false
            },
            editPago: function (data) {
                this.titlepagos = 'Editando Pago'
                this.viewbuttonback = true
                let fopago = {}
                this.pago = data.item,
                this.formaPago.forEach(function(element) {
                    if(element.codigo == data.item.formaPago){
                        fopago.codigo = element.codigo
                        fopago.nombre = element.nombre
                    }
                }),
                this.formadepago = fopago
                this.tipodemoneda = this.loadMoneda(data.item)
                this.importe = this.pago.importePagado
                this.numerooperacion = this.pago.numeroOperacion
                this.fpago = this.pago.fechaPago
                this.observaciones = this.pago.observaciones
                this.editando = true
                this.loadBanks()
            },
            loadMoneda: function (data) {
                let timoneda = {}
                this.tipoMoneda.forEach(function(element) {
                    if(element.codigo == data.tipoMoneda){
                        timoneda.id = element.id
                        timoneda.codigo = element.codigo
                        timoneda.descripcion = element.descripcion
                        timoneda.simbolo = element.simbolo
                    }
                })
                return timoneda
            },
            loadBanks: function () {
                if(this.listaBancos.length == 0){
                    this.listBanks()
                }
            },
            customFormatter: function (date) {
                // return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            },
            initDates: function () {    
                // this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            },
            listBanks: function () {
                this.cargandoBancos = true
                axios
                .post(process.env.VUE_APP_API_URL + 'infobanco/listar',{
                    token: this.$store.getters.userToken,
                    limit: '10',
                    order: 'desc'
                })
                .then(response => (
                    this.cargandoBancos = false,
                    this.listaBancos = response.data.data
                ))
                .catch(error => (
                    this.cargandoBancos = false
                ))
            },
            motivoRechazo: function (row) {
                if(row.item.aprobado === 2){
                    this.observacionRechazo = row.item.observaciones
                }else {
                    this.observacionRechazo = ''
                }
            },
            closerechazo: function () {
                this.motrechazo = false
            },
            viewPdf: function (data) {
                this.previewmodal = true,
                this.pdfobject = '',
                this.cargandopdf2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
                token: this.$store.getters.userToken,
                id: data.idDocumento
                })
                .then(response => (
                this.pdfobject = response.data.base64,
                this.cargandopdf2 = false
                ))
                .catch(error => {})
            },
            cerrarNotificaciones: function () {
                this.notificaciones = false
            },
            vernotificaciones: function (row) {
                this.cargandonotificaciones = true
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/alerta/listar',{
                    token: this.$store.getters.userToken,
                    receptor: row.item.receiver.idReceptor
                })
                .then(response => (
                    this.cargandonotificaciones = false,
                    this.evalResponseNotificacion(response.data.response)
                ))  
                .catch(error => (
                    this.cargandonotificaciones = false
                )) 
            },
            vernotificacionesvisto: function (data) {
                let alerta = []
                let item = {
                    id: ''
                }
                for(let i=0; i < data.length; i++){
                    alerta.push(data[i].idAlerta)
                }
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/alerta/visto',{
                    token: this.$store.getters.userToken,
                    alerta: alerta
                })
                .then(response => {})  
                .catch(error => {}) 
            },
            evalResponseNotificacion: function (value) {
                let count = 0
                if(value.length > 0){
                    this.listaNotificaciones = value,
                    this.vernotificacionesvisto(value),
                    this.$snotify.success(value.msg,'Exito')
                }else if(value.length === 0){
                    this.listaNotificaciones = [],
                    this.notificaciones = false,
                    this.$snotify.warning('No se encontraron resultados','Atención')
                }
            },
            cerrarlistapagos: function () {
                this.listarpagos = false
            },
            watchPayment: function (row) {
                this.listaPagos = []
                this.cargandopagos = true
                this.editando = false
                 axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/regularizar/listar',{
                    token: this.$store.getters.userToken,
                    id: row.item.idDocumentoCredito
                })
                .then(response => (
                    this.cargandopagos = false,
                    this.respuestaListaPago(response.data)
                ))  
                .catch(error => (
                    this.cargandopagos = false,
                    this.$snotify.error(error.response.data.message,'Error')
                )) 
            },
            respuestaListaPago: function (respuesta) {
                if(respuesta.success == 0){
                    this.listarpagos = false,
                    this.$snotify.warning(respuesta.msg,'Importante')
                }else if(respuesta.success == 1){
                    this.listaPagos = respuesta.pagos
                    this.ncpagos = respuesta.notas
                }
            },
            filtroDocumento: function () {
                this.filtrando = true
                if(this.filtro.length > 4){
                    axios
                    .post(process.env.VUE_APP_API_URL + 'documentoscredito/obtener',{
                        token: this.$store.getters.userToken,
                        filtro: 'name',
                        p: this.filtro
                    })
                    .then(response => (
                        this.filtrando = false,
                        this.docfiltrado.push(response.data.response),
                        this.$snotify.success(response.data.response.msg,'Exito')
                    ))  
                    .catch(error => (
                        this.filtrando = false,
                        this.$snotify.error(error.response.data.message,'Error')
                    )) 
                }
            },
            validFormularioPago: function () {
                if(this.importe != '' && this.tipodemoneda.codigo != '000' && this.formadepago.codigo != '000'){
                    return false
                }else{
                    return true
                }
            },
            mostrarDetalles: function (row, tipo, index) {
                this.indexApobar = 0
                this.indexApobado = 0
                if(tipo === 1){
                    if(row.detailsShowing){
                        row.toggleDetails()
                        this.cuentasxAprobar[index].mostrardetalles = false
                    }else{
                        this.cuentasxAprobar[index].mostrardetalles = true
                        this.cuentasxAprobar[index].loading = true
                        this.indexApobar = index
                        if (this.cuentasxAprobar[index].detalles.length == 0) {
                            setTimeout(() => this.detallesDocumento(row, 1), 10);
                        } else {
                            this.cuentasxAprobar[index].loading = false;
                            row.toggleDetails();
                        }
                    }
                }else if(tipo === 2){
                    if(row.detailsShowing){
                        row.toggleDetails()
                        this.cuentasAprobadas[index].mostrardetalles = false
                    }else{
                        this.cuentasAprobadas[index].mostrardetalles = true
                        this.cuentasAprobadas[index].loading = true
                        this.indexApobado = index
                        if (this.cuentasAprobadas[index].detalles.length == 0) {
                            setTimeout(() => this.detallesDocumento(row, 2), 10);
                        } else {
                            this.cuentasAprobadas[index].loading = false;
                            row.toggleDetails();
                        }
                    }
                } 
            },
            getDocumento: function (row, tipo) {
                if(row){
                    this.filaActual = row,
                    this.registropagotipo = tipo
                    this.idReceptor = row.item.idDocumentoCredito
                }else {
                    this.idReceptor = ''
                }
                this.tipodemoneda = this.loadMoneda(row.item)
                this.listBanks()
                this.sumaCuotas();
            },
            sumaCuotas(){
                let valor = 0
                this.arrayCuotas.forEach(function(element){
                        valor += parseFloat(element.montoPagoCuota)
                })
                return valor
            },
            pagoDeuda: function (tipo) {
                let ruta = ''
                let id = ''
                let importe = ''
                let fechapago = ''
                let infobanco = ''
                let paquete = {}
                this.actualizandopago = true
                this.sendpago = true
                this.banco == null ? infobanco = '': infobanco = this.banco.idInformacionBanco
                // this.fpago == '' ? fechapago = this.$moment().format('YYYY-MM-DD HH:MM:SS'): fechapago = this.$moment(this.fpago).format('YYYY-MM-DD HH:MM:SS')
                paquete.token = this.$store.getters.userToken
                if(tipo===1){
                    ruta = 'documentoscredito/emisor/regularizar'                
                    paquete.id = String(this.idReceptor)
                    paquete.importepagar = this.importe
                    paquete.tipomoneda = this.tipodemoneda.codigo
                    paquete.formapago = this.formadepago.codigo
                    paquete.fechapago = fechapago
                    paquete.numerooperacion = this.numerooperacion
                    paquete.idinformacionbanco = infobanco
                    paquete.observaciones = this.observaciones
                }else if(tipo===2){
                    ruta = 'documentoscredito/emisor/regularizar/editar'
                    paquete.id = this.pago.idDocumentoCreditoPago
                    paquete.importePagado = this.importe
                    paquete.formaPago = this.formadepago.codigo
                    paquete.fechaPago = fechapago
                    paquete.numeroOperacion = this.numerooperacion
                    paquete.idInformacionBancaria = infobanco
                    paquete.observaciones = this.observaciones
                    this.refreshpago = true
                }
                axios
                .post(process.env.VUE_APP_API_URL + ruta, paquete)
                .then(response => (
                    this.actualizandopago = false,
                    this.sendpago = false,
                    this.registrarpago = false,
                    this.listarpagos = false,
                    this.viewbuttonback = false,
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.initPago(tipo)
                ))  
                .catch(error => (
                    this.actualizandopago = false,
                    this.sendpago = false,
                    this.$snotify.error(error.response.data.msg,'Error')
                )) 
            },
            initPago: function (tipo) {
                this.idReceptor = ''
                this.importe = ''
                this.tipodemoneda = {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                this.formadepago = {
                    codigo: '000',
                    nombre: 'Elige Forma de Pago'
                },
                this.observaciones = '',
                this.mostrarDetalles(this.pago, tipo, this.indexApobado)
                if(this.registropagotipo===1){
                    this.listaCobrosAprobadas()
                }
            },
            detallesDocumento: function (row, tipo) {
                let aprob = ''
                let receptor = ''
                if(tipo === 1){
                    aprob = 'no'
                }else if(tipo === 2){
                    aprob = 'si'
                }
                this.refreshpago ? receptor = this.pago.creditdocument.idReceptor: receptor = row.item.idReceptor 
                this.detallesCuentaAprobada = row.item
                this.viewdetails = true
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/receptor',{
                    token: this.$store.getters.userToken,
                    receptor: receptor,
                    aprobado: aprob
                })
                .then(response => (
                    this.parseDetallesDocumento(response.data.data, row, tipo)
                ))
                .catch(error => (  
                    this.viewdetails = false,
                    this.cuentasxAprobar[row.index].mostrardetalles = false,
                    this.cuentasAprobadas[row.index].mostrardetalles = false
                )) 
            },
            parseDetallesDocumento: function (value, row, tipo) {
                this.viewdetails = false
                if(tipo === 1){
                    this.cuentasxAprobar[this.indexApobar].detalles = value
                    this.cuentasxAprobar[this.indexApobar].loading = false
                    if(value.length > 0){
                    row.toggleDetails()
                    }
                }else if(tipo === 2){
                    this.cuentasAprobadas[this.indexApobado].detalles = value
                    this.cuentasAprobadas[this.indexApobado].loading = false
                    if(value.length > 0){
                    row.toggleDetails()
                    }
                }
            },
            nuevoItem: function (value) {
                let anterior = this.itemactual
                this.itemactual = value
                if(anterior != this.itemactual){
                    return true
                }else{
                    return false
                }  
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            listaCobrosxAprobar: function () {
                this.isBusy = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito',{
                    token: this.$store.getters.userToken,
                    aprobado: 'no',
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response => (
                    this.isBusy = false,
                    this.cuentasxAprobar = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.cuentasxAprobar.forEach(function(element) {
                        element.loading = false
                    })        
                ))
                .catch(error => {
                    this.isBusy = false
                })
            },
            listaCobrosAprobadas: function () {
                this.aprobadas = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito',{
                    token: this.$store.getters.userToken,
                    aprobado: 'si',
                    page: this.currentPageA,
                    limit: this.limiteA,
                    order: this.ordenA
                })
                .then(response => (
                    this.aprobadas = false,
                    this.cuentasAprobadas = response.data.data,
                    this.totalA = response.data.total,
                    this.desdeA = response.data.from,
                    this.hastaA = response.data.to,
                    this.cuentasAprobadas.forEach(function(element) {
                        element.loading = false
                    })  
                ))
                .catch(error => {
                    this.aprobadas = false
                })
            },
            rowClass(item, type) {
                if (!item || type !== 'row') return
                if (item.tieneNota === 1) return 'table-danger'
            },
            rangouser(){
                this.user =  this.$store.getters.userData.perfil.rolUsuario
                if(this.user == 3){
                    this.nivelusuario = false
                }else{
                    this.nivelusuario = true;
                }
            },
            enviarAestadoCuenta(ruc,numero){
                this.$emit("tabindex", numero);
                this.$emit("ruc", ruc.idReceptor);
            },
            importarPagos(){
            this.formData = new FormData();
            this.formData.append("token", this.$store.getters.userToken);
            this.formData.append("pagos", this.file1);
            axios
                .post(
                process.env.VUE_APP_API_URL + "documentoscredito/pagoreceptor/importar",
                this.formData,
                {
                    responseType: "blob",
                    headers: {
                    "Content-Type": "multipart/form-data"
                    }
                }
                )
                .then(response => {
                console.log(response);
                })
                .catch(error => {
                console.log(error);
                });  
            },
            eliminarFile(){
                this.file1 = null
            }
        }
    }
</script>

<style>
    .cuentasaprobadas{
        background-color: rgb(40, 30, 85);
        margin-top: 500px;
    }
    .badgesuccess{
        font-size: 12px;
        width: 30px;
        height: 30px;
        margin: 0px;
        padding: 0px;
        padding-top: 8px;
    }
    .cuentasaprobar{
        background-color: #ccc;
        color: blue;
    }
    .detallescobrar{
        background-color: blue;
    }
    .noti{
       background-color: blue;
       width: 50px;
       height: 20px;
       margin-top: -30px;
    }
    .searcher-field{
        z-index: 1000;
        position: absolute;
        max-height: 400px !important;
        overflow-y: scroll;
        width: 500px
    }
    .searcher-result{
        font-size: smaller;
        padding: 2px 0px 2px 0px;
        cursor: pointer;
    }
</style>